import { getIsLoading, getListParams } from '../../Shared/selectors';

const getBrivoCleanupUsers = (state) =>
  state?.externalAccounts?.brivoCleanupUsers ?? {};

export { getBrivoCleanupUsers, getListParams, getIsLoading };
